
import { GameRole } from '../../types/game';
import { skills } from '../skills';
import { challenges } from '../challenges';

export const operationsRole: GameRole = {
  id: 'operations',
  title: 'Operations Manager',
  description: 'Oversee daily mining operations, focusing on efficiency and profitability. Balance technical requirements with business objectives while managing facility logistics.',
  difficulty: 'Medium',
  strengths: [
    'Balanced KPI improvement',
    'Strong operational efficiency',
    'Good risk management'
  ],
  startingSkills: [
    skills.find(s => s.id === 'facility-management')!
  ],
  careerPath: [
    {
      level: 'Junior',
      title: 'Operations Manager',
      requiredExperience: 0,
      requiredYears: 0
    },
    {
      level: 'Mid-Level',
      title: 'Senior Operations Manager',
      requiredExperience: 150,
      requiredYears: 3
    },
    {
      level: 'Senior',
      title: 'Operations Director',
      requiredExperience: 350,
      requiredYears: 6
    },
    {
      level: 'Leader',
      title: 'Chief Operating Officer',
      requiredExperience: 700,
      requiredYears: 10
    }
  ],
  specialChallenges: [
    challenges.find(c => c.id === 'equipment-shortage')!
  ],
  careerObjectives: [
    {
      title: 'Efficiency Champion',
      description: 'Achieve 85% operational efficiency for 6 consecutive months',
      target: {
        kpi: 'efficiency',
        value: 85
      },
      reward: 'Operations Excellence Badge'
    }
  ]
};
